import { Controller } from "@hotwired/stimulus"

// Debounces a form submission triggered by an input event. Pair with a
// <form data-turbo-frame="..."> to render debounced GET responses into a
// Turbo Frame (typeahead search pattern).
//
//   <form data-controller="debounce" data-turbo-frame="results">
//     <input data-action="input->debounce#perform" data-debounce-wait-value="250">
//   </form>
export default class extends Controller {
  static values = { wait: { type: Number, default: 250 } }

  perform() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.element.requestSubmit(), this.waitValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
